/**
 * Parses the posting style string from the API into a plain object.
 * e.g. "{backgroundColor:'#FFFFC2', color: #007AD7}" → { backgroundColor: '#FFFFC2', color: '#007AD7' }
 */
export const parsePostingStyle = (styleStr) => {
  if (!styleStr) return { backgroundColor: "", color: "" };
  const bgMatch = styleStr.match(/backgroundColor\s*:\s*['"]?([^,'"}\s]+)['"]?/);
  // Match `color:` but NOT `backgroundColor:`
  const colorMatch = styleStr.match(/(?<![a-zA-Z])color\s*:\s*['"]?([^,'"}\s]+)['"]?/);
  return {
    backgroundColor: bgMatch ? bgMatch[1] : "",
    color: colorMatch ? colorMatch[1] : "",
  };
};

/**
 * Serializes individual color values back into the posting style string format.
 * e.g. ('#FFFFC2', '#007AD7') → "{backgroundColor:'#FFFFC2', color: #007AD7}"
 */
export const serializePostingStyle = (backgroundColor, color) => {
  const parts = [];
  if (backgroundColor && backgroundColor !== "none") {
    parts.push(`backgroundColor:'${backgroundColor}'`);
  }
  if (color && color !== "none") {
    parts.push(`color: ${color}`);
  }
  return parts.length ? `{${parts.join(", ")}}` : "";
};
